"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/chart.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fchart.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.chartCompressionToJSON = exports.chartCompressionFromJSON = exports.chartTimeRangeToJSON = exports.chartTimeRangeFromJSON = exports.ChartCompression = exports.ChartTimeRange = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto';
/**
 * TODO(luke): Migrate stock service to use shared proto
 */
var ChartTimeRange;
(function (ChartTimeRange) {
    ChartTimeRange["INVALID_CHART_TIME_RANGE"] = "INVALID_CHART_TIME_RANGE";
    ChartTimeRange["ONE_DAY"] = "ONE_DAY";
    ChartTimeRange["ONE_WEEK"] = "ONE_WEEK";
    ChartTimeRange["ONE_MONTH"] = "ONE_MONTH";
    ChartTimeRange["THREE_MONTHS"] = "THREE_MONTHS";
    ChartTimeRange["ONE_YEAR"] = "ONE_YEAR";
    ChartTimeRange["FIVE_YEARS"] = "FIVE_YEARS";
    ChartTimeRange["ALL_TIME"] = "ALL_TIME";
    ChartTimeRange["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ChartTimeRange || (exports.ChartTimeRange = ChartTimeRange = {}));
var ChartCompression;
(function (ChartCompression) {
    ChartCompression["INVALID_CHART_COMPRESSION"] = "INVALID_CHART_COMPRESSION";
    ChartCompression["DAY"] = "DAY";
    ChartCompression["MINUTE"] = "MINUTE";
    ChartCompression["FIVE_MINUTES"] = "FIVE_MINUTES";
    ChartCompression["THIRTY_MINUTES"] = "THIRTY_MINUTES";
    ChartCompression["HOUR"] = "HOUR";
    ChartCompression["WEEK"] = "WEEK";
    ChartCompression["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ChartCompression || (exports.ChartCompression = ChartCompression = {}));
function chartTimeRangeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CHART_TIME_RANGE':
            return ChartTimeRange.INVALID_CHART_TIME_RANGE;
        case 1:
        case 'ONE_DAY':
            return ChartTimeRange.ONE_DAY;
        case 2:
        case 'ONE_WEEK':
            return ChartTimeRange.ONE_WEEK;
        case 3:
        case 'ONE_MONTH':
            return ChartTimeRange.ONE_MONTH;
        case 4:
        case 'THREE_MONTHS':
            return ChartTimeRange.THREE_MONTHS;
        case 5:
        case 'ONE_YEAR':
            return ChartTimeRange.ONE_YEAR;
        case 6:
        case 'FIVE_YEARS':
            return ChartTimeRange.FIVE_YEARS;
        case 7:
        case 'ALL_TIME':
            return ChartTimeRange.ALL_TIME;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ChartTimeRange.UNRECOGNIZED;
    }
}
exports.chartTimeRangeFromJSON = chartTimeRangeFromJSON;
function chartTimeRangeToJSON(object) {
    switch (object) {
        case ChartTimeRange.INVALID_CHART_TIME_RANGE:
            return 'INVALID_CHART_TIME_RANGE';
        case ChartTimeRange.ONE_DAY:
            return 'ONE_DAY';
        case ChartTimeRange.ONE_WEEK:
            return 'ONE_WEEK';
        case ChartTimeRange.ONE_MONTH:
            return 'ONE_MONTH';
        case ChartTimeRange.THREE_MONTHS:
            return 'THREE_MONTHS';
        case ChartTimeRange.ONE_YEAR:
            return 'ONE_YEAR';
        case ChartTimeRange.FIVE_YEARS:
            return 'FIVE_YEARS';
        case ChartTimeRange.ALL_TIME:
            return 'ALL_TIME';
        case ChartTimeRange.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.chartTimeRangeToJSON = chartTimeRangeToJSON;
function chartCompressionFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CHART_COMPRESSION':
            return ChartCompression.INVALID_CHART_COMPRESSION;
        case 1:
        case 'DAY':
            return ChartCompression.DAY;
        case 2:
        case 'MINUTE':
            return ChartCompression.MINUTE;
        case 3:
        case 'FIVE_MINUTES':
            return ChartCompression.FIVE_MINUTES;
        case 4:
        case 'THIRTY_MINUTES':
            return ChartCompression.THIRTY_MINUTES;
        case 5:
        case 'HOUR':
            return ChartCompression.HOUR;
        case 6:
        case 'WEEK':
            return ChartCompression.WEEK;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ChartCompression.UNRECOGNIZED;
    }
}
exports.chartCompressionFromJSON = chartCompressionFromJSON;
function chartCompressionToJSON(object) {
    switch (object) {
        case ChartCompression.INVALID_CHART_COMPRESSION:
            return 'INVALID_CHART_COMPRESSION';
        case ChartCompression.DAY:
            return 'DAY';
        case ChartCompression.MINUTE:
            return 'MINUTE';
        case ChartCompression.FIVE_MINUTES:
            return 'FIVE_MINUTES';
        case ChartCompression.THIRTY_MINUTES:
            return 'THIRTY_MINUTES';
        case ChartCompression.HOUR:
            return 'HOUR';
        case ChartCompression.WEEK:
            return 'WEEK';
        case ChartCompression.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.chartCompressionToJSON = chartCompressionToJSON;
//# sourceMappingURL=chart.js.map